import LocationGraphics from './LocationGraphics';
import gsap from "gsap";

let assetArray = [];
let nana;
let nanaUnder;
let nanaBottom;

export default class KaumatuaPorchGraphics extends LocationGraphics {
    constructor() {
        super('kaumatuaPorchGraphics');
        this.assetArray = assetArray;
    }

    preload() {
        //there are no new graphics to preload for this scene
        super.ready(this);
    }

    addGraphics(container) {
        //let gameScale = this.registry.values.scaleIt;
        this.parent.cameras.main.setBackgroundColor('rgba(0, 0, 0, 1)');

        container.add(this.utils.addImage(this.parent, {
            id: 'kaumatuaPorch',
            x: -425,
            y: -618
        }));


        nanaUnder = this.utils.addImage(this.parent, {
            id: 'nanaUnder',
            x: 175,
            y: 320,
            originY: 1
        });

        nanaBottom = this.utils.addImage(this.parent, {
            id: 'nanaBottom',
            x: 55,
            y: 440,
            originY: 1
        });

        nana = this.utils.addImage(this.parent, {
            id: 'nana',
            x: 20,
            y: 371,
            originY: 1
        });
        container.add(nanaUnder, nanaBottom, nana);


        container.add(this.utils.addImage(this.parent, {
            x: -10,
            y: 345,
            maori: 'whakamahau / mahau',
            english: 'porch',
            hit: [
                [0, 89],
                [0, 0],
                [1051, 0],
                [976, 130],

            ]
        }));
        container.add(this.utils.addImage(this.parent, {
            x: 422,
            y: 284,
            maori: 'kamupūtu',
            english: 'gumboots',
            hit: [
                [0, 100],
                [0, 0],
                [64, 0],
                [91, 107],

            ]
        }));

        container.add(this.utils.addImage(this.parent, {
            x: 250,
            y: 0,
            maori: 'matapihi',
            english: 'window',
            hit: [
                [0, 0],
                [151, 0],
                [151, 157],
                [0, 157],

            ]
        }));
        container.add(this.utils.addImage(this.parent, {
            x: 20,
            y: 161,
            maori: 'tūru hurōrirori',
            english: 'rocking chair',

            hit: [
                [45, 234],
                [0, 27],
                [133, 0],
                [249, 78],
                [241, 210],
                [141, 265],

            ]
        }));




        this.animate();


        // this.parent.startToolTips();
        super.addGraphics();
    }

    animate() {
        let rockerGS = gsap.timeline({
            repeat: -1,
            repeatDelay: 0.1,
            yoyo: true,
            defaults: { // children inherit these defaults
                duration: 1,
                ease: "ease.inOut",
                rotation: -0.05
            },

        });
        rockerGS.to(nana, {})
            .to(nanaUnder, {}, "<")

    }
}